var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"card-counter",class:_vm.counterOuterClass},[_c('i',{class:_vm.counterIconClass}),(!_vm.skill)?_c('span',[_vm._v(_vm._s(_vm.value))]):_c('span',{staticClass:"card-counter__text"},[_vm._v(_vm._s(_vm.skill))])])}
var staticRenderFns = []

export { render, staticRenderFns }